/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-throw-literal */
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import { usePermission } from "../../../shared";
import { getSeoDetailApi, updateSeoDetailApi } from "../api/CategoryApi";
import { errorMessage, successMessage } from "../../../utils";
import React from "react";
import SimpleReactValidator from "simple-react-validator";
import { AppContext } from "../../../store";

export const useManageCategorySeo = ({ detailsPage = true }) => {
  const { categoryId, id } = useParams();
  const [, setForceUpdate] = React.useState();
  const [state, setState] = useImmer({
    seoDetails: {
      slug: "",
      meta_title: "",
      header: "",
      meta_description: "",
    },
    isFormDetailsLoading: true,
    updateButtonLoading: false,
    isFormUpdated: false,
  });
  const { appState } = React.useContext(AppContext);
  const { categoryDetails: currentTab } = appState.currentTabs;

  const navigate = useNavigate();
  const location = useLocation();

  const isEditable = usePermission("category-modify");

  const formValidator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
      element: (message) => message,
    })
  );

  // ==================================================== API SECTION ==================================================
  const getSeoDetail = async (categoryId) => {
    try {
      triggerDetailsLoading(true);
      const response = await getSeoDetailApi(categoryId);
      const { success, data, message } = response;
      if (success) {
        setState((draft) => {
          draft.seoDetails = data;
        });
      } else {
        throw {
          response: {
            data: {
              message,
            },
          },
        };
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ?? "Field to fetch seo details";

      errorMessage(message);
    } finally {
      triggerDetailsLoading(false);
    }
  };

  const updateSeo = async ({ categoryId, seoDetails }) => {
    triggerUpdateButtonLoading(true);
    try {
      const response = await updateSeoDetailApi({
        categoryId,
        payload: seoDetails,
      });
      const { success, message } = response;
      if (success) {
        successMessage("SEO details updated successfully");
        navigate(`/category/details/${categoryId}`);
      } else {
        throw {
          response: {
            data: {
              message,
            },
          },
        };
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ?? "Failed to update the SEO details";
      errorMessage(message);
    } finally {
      triggerUpdateButtonLoading(false);
    }
  };

  // ==================================================== UTIL FUNCTION SECTION ==================================================
  const triggerDetailsLoading = (isLoading) => {
    setState((draft) => {
      draft.isFormDetailsLoading = isLoading;
    });
  };

  const triggerUpdateButtonLoading = (isLoading) => {
    setState((draft) => {
      draft.updateButtonLoading = isLoading;
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setState((draft) => {
      draft.seoDetails[name] = value;
      draft.isFormUpdated = true;
    });
  };

  const handleUpdateSeo = async () => {
    if (formValidator.current.allValid()) {
      await updateSeo({ categoryId, seoDetails: state.seoDetails });
    } else {
      formValidator.current.showMessages();
      setForceUpdate(0);
    }
  };

  // ==================================================== USER EFFECT SECTION ==================================================
  React.useEffect(() => {
    // Redirect to /category if location state does not have a name
    if (detailsPage === false && !location.state?.name) navigate("/category");
  }, []);

  React.useEffect(() => {
    if ((currentTab === "3" && detailsPage) || detailsPage === false) {
      getSeoDetail(categoryId ?? id);
    }
  }, [currentTab]);

  return {
    formValidator,
    state,
    isEditable,
    handleUpdateSeo,
    handleFormChange,
  };
};
